import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const WATERMELON_ROUTE_NAMES = new Set(["signup-watermelon", "edit-watermelon"]);

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_URL),
    routes: [
        {
            path: "/migrate",
            name: "migrate",
            component: () => import(`@/views/CommonAccountMigration.vue`),
        },
        {
            path: "/sign-up",
            name: "signup",
            component: () => import(`@/views/CommonAccountSignUp.vue`),
        },
        {
            path: "/update-term",
            name: "update-term",
            component: () => import(`@/views/CommonAccountUpdateTerm.vue`),
        },
        {
            path: "/edit",
            name: "edit",
            component: () => import(`@/views/CommonAccountEdit.vue`),
        },
        {
            path: "/find",
            name: "find",
            component: () => import(`@/views/CommonAccountFind.vue`),
        },
        {
            path: "/connect-service",
            name: "connect-service",
            component: () => import(`@/views/CommonAccountConnectService.vue`),
        },
        {
            path: "/login",
            name: "login",
            component: () => import(`@/views/MasterLogin.vue`),
        },
        {
            path: "/sign-up-watermelon",
            name: "signup-watermelon",
            component: () => import(`@/views/temporary/CommonAccountsTemporarySignUp.vue`),
        },
        {
            path: "/edit-watermelon",
            name: "edit-watermelon",
            component: () => import(`@/views/temporary/CommonAccountsTemporaryEdit.vue`),
        },
    ],
});

router.beforeEach(async (to) => {
    if (!WATERMELON_ROUTE_NAMES.has(String(to.name))) return true;

    const authStore = useAuthStore();
    const kept = await authStore.ensureMasterSession();
    if (kept) return true;

    return {
        name: "login",
        query: {
            redirect: to.fullPath,
        },
        replace: true,
    };
});

export default router;
